import {
    useMemo,
} from 'react'

import request from 'app/requests/ActivityRecords.requests'
import {
    ArchiveButton, useArchive, ArchiveConfirmationDialog,
} from 'app/shared-components/Archive'
import {
    ActivityRecord,
} from 'app/Apps/RelationshipsManagement/ActivityRecords/activityRecords.types'
import ActivityRecordForm from 'app/Apps/RelationshipsManagement/ActivityRecords/ActivityRecordForm'

function ActivityRecordDemoEditForm({
    data,
    onSuccess,
    onCancel,
    backPath = undefined,
}: Readonly<{
    data: ActivityRecord,
    onSuccess: () => void,
    onCancel: () => void,
    backPath?: string,
}>) {
    const archive = useArchive({
        requestParamFn: data?.archived ? request.restore
            : request.archive,
        notificationId: 'ActivityRecordUpdate',
        title: 'Activity Record',
        data,
        redirectionAfterSuccess: backPath,
    })

    const customButtons = useMemo(() => {
        return [<ArchiveButton
            onClick={archive.handleArchiveRestore}
            archived={data?.archived}
        />]
    }, [
        archive,
        data?.archived,
    ])

    return (
        <>
            <ActivityRecordForm
                requestParam={request.update(data.id)}
                data={data}
                onSuccess={onSuccess}
                onCancel={onCancel}
                customButtons={customButtons}
            />
            <ArchiveConfirmationDialog
                title="Activity Record"
                openConfirmDialog={archive.openConfirmDialog}
                handleClose={archive.handleArchiveRestoreConfirm}
                archived={data?.archived}
            />
        </>
    )
}

export default ActivityRecordDemoEditForm
